import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createEncoder } from '../api/encoderApi';
import {
  getCapacidadesByPaciente,
  updateCapacidad,
} from '../../capacidad_funcional/api/capacidadFuncionalApi';
import {
  calcularEquilibrio,
  calcularDesplazamiento,
  calcularFuerza,
} from '../../capacidad_funcional/hooks/useCapacidadFuncionalForm';

/**
 * Busca el registro SPPB más reciente del paciente y lo actualiza con
 * el tiempo 5STS recién guardado en el Encoder, recalculando puntosSPPB.
 */
const sincronizarSPPB = async (idPaciente, tiempo5STS) => {
  try {
    const registros = await getCapacidadesByPaciente(idPaciente);
    if (!registros || registros.length === 0) return;

    // Más reciente primero
    const ultimo = [...registros].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    )[0];

    const ptEquilibrio     = calcularEquilibrio(ultimo.tiempoPiesJuntos, ultimo.tiempoSemitandem, ultimo.tiempoTandem);
    const ptDesplazamiento = calcularDesplazamiento(ultimo.tiempoDesplazamiento);
    const ptFuerza         = calcularFuerza(tiempo5STS);
    const nuevoPuntosSPPB  = ptEquilibrio + ptDesplazamiento + ptFuerza;

    await updateCapacidad({
      codigoInforme: ultimo.codigo,
      payload: {
        sentadillas: parseFloat(tiempo5STS),
        puntosSPPB: nuevoPuntosSPPB,
      },
    });

    console.info(`SPPB actualizado — registro ${ultimo.codigo}, puntos: ${nuevoPuntosSPPB}`);
  } catch (err) {
    // No es un error crítico; el encoder se guardó igualmente
    console.warn('No se pudo sincronizar el SPPB:', err);
  }
};

export const useEncoderForm = ({ idPaciente, tiempo5STS = '' }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    codigoPrueba: '',
    velocidad: '',
    potencia: '',
    distancia: '',
    tiempo5STS,
  });
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [sppbSincronizado, setSppbSincronizado] = useState(false);

  useEffect(() => {
    if (tiempo5STS) {
      setFormData((prev) => ({ ...prev, tiempo5STS }));
    }
  }, [tiempo5STS]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const guardarDatos = async () => {
    const userId = localStorage.getItem('id');
    try {
      await createEncoder({
        pacienteId: idPaciente,
        userId,
        payload: {
          codigoPrueba: formData.codigoPrueba,
          velocidad: formData.velocidad,
          potencia: formData.potencia,
          distancia: formData.distancia,
          tiempo5STS: formData.tiempo5STS,
        },
      });

      // Sincronizar 5STS → SPPB si hay tiempo registrado
      if (formData.tiempo5STS) {
        await sincronizarSPPB(idPaciente, formData.tiempo5STS);
        setSppbSincronizado(true);
      }

      setOpenGood(true);
      setTimeout(() => { navigate('/home'); }, 2000);
    } catch (error) {
      console.error('Error al guardar el encoder:', error);
      setOpenError(true);
    }
  };

  return {
    formData,
    openGood,
    openError,
    sppbSincronizado,
    setOpenGood,
    setOpenError,
    handleChange,
    guardarDatos,
  };
};
